import BackendService from './BackendService';
import { STORAGE_KEYS } from 'const';
async function getBillSummaryReport(data = {}) {
  return BackendService.postData('/reports/sales-summary/', data);
}
async function getReturnedBillSummaryReport(data = {}) {
  return BackendService.postData('/reports/returned-sales-summary/', data);
}
async function getBillSummaryReportWithProfif(data = {}) {
  return BackendService.postData('/reports/sales-summary/profit/', data);
}
async function getBillSummaryCsv(data = {}) {
  return BackendService.post('/reports/bills/', data);
}
async function getBillDetails(data = {}) {
  return BackendService.postData('/reports/sales/details/', data);
}
async function getProfitBillDetails(data = {}) {
  return BackendService.postData('/reports/sales/details/profit/', data);
}
async function getDayWiseReport(data = {}) {
  return BackendService.postData('/reports/day-wise/', data);
}
async function getDayWiseReportWithProfit(data = {}) {
  return BackendService.postData('/reports/day-wise/profit/', data);
}
async function getCashierSalesReport(data = {}) {
  return BackendService.postData('/reports/cashier-sales-summary/', data);
}
async function getWaiterSalesReport(data = {}) {
  return BackendService.postData('/reports/waiter-sales-summary/', data);
}
async function getCategorySalesReport(data = {}) {
  return BackendService.postData('/reports/category-sales-summary/', data);
}
async function exportBillToPdf(data = {}) {
  const authToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
  return BackendService.getData(
    '/reports/bills/details/pdf/',
    {},
    {
      token: authToken,
      machine_no: data.machine_no,
      bill_no: data.bill_no,
    }
  );
}
async function voidInvoice(inoiceId, data = {}) {
  return BackendService.patch(`/sales/${inoiceId}/void/`, data);
}
async function getNcBillSummaryReport(data = {}) {
  return BackendService.postData('/reports/nc-sales-summary/', data);
}
async function getStaffProductSalesReport(data = {}) {
  return BackendService.postData('/reports/staff-product-sales-summary/', data);
}
async function getSalesEditReport(data = {}) {
  return BackendService.postData('/reports/sales-edit-summary/', data);
}
async function getMonthlySummaryProfitReport(data = {}) {
  return BackendService.postData('/reports/monthly-summary/profit/', data);
}

const BillSummaryReportService = {
  getBillSummaryReport,
  getBillSummaryCsv,
  getBillDetails,
  getProfitBillDetails,
  exportBillToPdf,
  getBillSummaryReportWithProfif,
  getDayWiseReportWithProfit,
  getDayWiseReport,
  getWaiterSalesReport,
  getCashierSalesReport,
  getCategorySalesReport,
  getReturnedBillSummaryReport,
  getNcBillSummaryReport,
  getStaffProductSalesReport,
  getSalesEditReport,
  getMonthlySummaryProfitReport,
  voidInvoice,
};

export default BillSummaryReportService;
